import { createInfiniteRepository } from "shared/api/infinite-repository";
import { graphql } from "src/gql";
import { singleton } from "tsyringe";

@singleton()
export class GroupSearchRepository extends createInfiniteRepository(
    graphql(`
        query GroupSearchRepository($offset: Int!, $limit: Int!, $queryMembership: Boolean!, $query: String) {
            searchGroups(offset: $offset, limit: $limit, query: $query, permissions: []) {
                ...FullGroupLike
                aboutMembership @include(if: $queryMembership) {
                    allMembersCount
                }
            }
        }
    `),
    {
        page: (doc) => doc.searchGroups,
        sort: { by: (it) => it.name, ord: "asc" },
    },
) {}

@singleton()
export class GroupChildrenRepository extends createInfiniteRepository(
    graphql(`
        query GroupChildrenRepository($offset: Int!, $limit: Int!, $parentId: UUID!, $queryMembership: Boolean!) {
            group(id: $parentId) {
                childrenPaged(offset: $offset, limit: $limit) {
                    ...FullGroupLike
                    aboutMembership @include(if: $queryMembership) {
                        allMembersCount
                    }
                }
            }
        }
    `),
    {
        page: (doc) => doc.group.childrenPaged,
        sort: { by: (it) => it.name, ord: "asc" },
        prefetchFirstPage: false,
    },
) {}

@singleton()
export class GroupParentsRepository extends createInfiniteRepository(
    graphql(`
        query GroupParentsRepository($offset: Int!, $limit: Int!, $childId: UUID!, $queryMembership: Boolean!) {
            group(id: $childId) {
                parentsPaged(offset: $offset, limit: $limit) {
                    ...FullGroupLike
                    aboutMembership @include(if: $queryMembership) {
                        allMembersCount
                    }
                }
            }
        }
    `),
    {
        page: (doc) => doc.group.parentsPaged,
        sort: { by: (it) => it.name, ord: "asc" },
    },
) {}

@singleton()
export class GroupMembersRepository extends createInfiniteRepository(
    graphql(`
        query GroupMembersRepository($offset: Int!, $limit: Int!, $id: UUID!) {
            group(id: $id) {
                aboutMembership {
                    directMembers(offset: $offset, limit: $limit) {
                        ...MemberLike
                    }
                }
            }
        }
    `),
    {
        page: (doc) => doc.group.aboutMembership.directMembers,
        sort: { by: (it) => it.id, ord: "asc" },
    },
) {}

@singleton()
export class UserMembershipSearchRepository extends createInfiniteRepository(
    graphql(`
        query UserMembershipSearchRepository($offset: Int!, $limit: Int!, $search: String) {
            users(limit: $limit, offset: $offset, nameQuery: $search) {
                id
                name
                loginEmail
                groups {
                    id
                    name
                }
                euds {
                    type
                    value
                }
            }
        }
    `),
    {
        page: (doc) => doc.users,
    },
) {}
